exports.grammar = require("./tmLanguage.json");
exports.grammarConfig = {};
exports.editorConfig = {};
